import { HeaderBGEnum } from '../../types/_bg';
import { type HeaderThemeProps } from '../../types/_theme';
import headerColorClasses from './_colors';

const headerClasses = 'z-40 text-sm';
const headerContainerThemeClasses = '';
const headerNavContainerThemeClasses = 'h-auto hidden mdL:h-full mdL:flex';
const headerBehaviorClasses = 'sticky top-0 transform duration-300';

const headerShadowClasses = 'drop-shadow-lg';
const headerInvisibleClasses = 'opacity-0 pointer-events-none';

const headerSiteTheme = ({ bg = 'Light' }: HeaderThemeProps) => ({
  headerClasses,
  headerContainerThemeClasses,
  headerNavContainerThemeClasses,
  headerColorClasses: headerColorClasses.get(HeaderBGEnum[bg]),
  headerBehaviorClasses,
  headerShadowClasses,
  headerInvisibleClasses,
});

export default headerSiteTheme;
